import { useEffect, useState } from 'react';

import { getHousekeepingReport } from 'api/housekeeping-reports';
import HousekeepingProtocolReport from './HousekeepingProtocolReport';

/**
 * Loads the housekeeping report with the given id (including its protocol and the data of the
 * sales case) and renders it. The drawer opens right away with a loading state.
 */
function HousekeepingProtocolReportWrapper({ reportId, handleClose }) {
  const [report, setReport] = useState(null);

  useEffect(() => {
    // The last loaded report is kept when closing so the drawer doesn't empty while it slides out
    if (!reportId) {
      return;
    }

    let cancelled = false;
    setReport(null);
    getHousekeepingReport(reportId)
      .then((loadedReport) => !cancelled && setReport(loadedReport))
      .catch(() => {
        if (!cancelled) {
          alert('Failed to load housekeeping report');
          handleClose();
        }
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportId]);

  return (
    <HousekeepingProtocolReport
      open={Boolean(reportId)}
      loading={Boolean(reportId) && !report}
      report={report || {}}
      protocol={report?.Protocol || {}}
      handleClose={handleClose}
    />
  );
}

export default HousekeepingProtocolReportWrapper;
